import { Component, OnInit, HostBinding, Input, HostListener, ViewChild, ElementRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthConfigService } from '../../services/auth-config/auth-config.service';

@Component({
  selector: 'ags-auth-home-button',
  templateUrl: './auth-home-button.component.html',
  styleUrls: ['./auth-home-button.component.scss']
})
export class AuthHomeButtonComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  @ViewChild('anchor') public anchor: ElementRef;
  @ViewChild('popup', { read: ElementRef }) public popup: ElementRef;
  @Input() landingRoute: string[];

  public show = false;

  constructor(router: Router, authConfigService: AuthConfigService) {
    this.themeFlag = `${this.themeFlag || ''} ${authConfigService.themingClassName} exported`;
    router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        this.show = false;
      }
    });
  }

  ngOnInit() {}

  @HostListener('keydown', ['$event'])
  public keydown(event: any): void {
    if (event.keyCode === 27) {
      this.toggle(false);
    }
  }

  @HostListener('document:click', ['$event'])
  public documentClick(event: any): void {
    if (!this.contains(event.target)) {
      this.toggle(false);
    }
  }

  public toggle(show?: boolean): void {
    this.show = show !== undefined ? show : !this.show;
  }

  private contains(target: any): boolean {
    return (
      this.anchor.nativeElement.contains(target) || (this.popup ? this.popup.nativeElement.contains(target) : false)
    );
  }
}
